<template>
    <div class="d-flex justify-start ga-2 align-center">
        <div class="text-h5 font-weight-bold">Résultats du {{ title }}</div>
        <v-chip color="accent" variant="flat">
            {{ current_sexe == 'f' ? 'Féminin' : 'Mixte' }}
        </v-chip>
    </div>
</template>

<script>
export default {
    name: "TheTitle",

    computed: {
        current_sexe() {
            return this.$store.state.current_sexe;
        },
        title() {
            const current_epreuve = this.$store.state.current_epreuve;

            if (current_epreuve == 'raid') {
                return "Raid";
            } else if (current_epreuve == 'kayak') {
                return "Kayak";
            } else if (current_epreuve == 'trail') {
                return "Trail";
            } else if (current_epreuve == 'penalite') {
                return "Tir à l'arc";
            }
            return "Raid";
        }
    }
}
</script>

<style lang="scss" scoped></style>